import { useEffect, useRef, useState } from 'react';

function useElementHeight(dependency) {
  const ref = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!dependency) {
      setHeight(0);
      return;
    }
    const el = ref.current;
    if (!el) return;
    const observer = new ResizeObserver(() => {
      setHeight(el.offsetHeight);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [dependency]);

  return [ref, height];
}

export default useElementHeight;
